import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';

import { colors } from 'src/themes/colors';
import { mediaQuery } from 'src/themes/breakpoints';
import { ButtonAppearance } from './constants';

export const baseButtonStyles = css`
  align-items: center;
  background-color: ${colors.orange500};
  border: none;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  box-sizing: border-box;
  color: ${colors.grey100};
  cursor: pointer;
  display: flex;
  font-size: 18px;
  font-weight: 700;
  justify-content: center;
  letter-spacing: 0.8px;
  min-height: 40px;
  padding: 0 20px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 300ms;

  &:hover {
    background-color: ${colors.blue};
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
    transform: translateY(-3px);
  }

  &:focus:not(:focus-visible) {
    outline: 0;
  }
`;

export const ButtonAppearancesStyles = css<ButtonProps>`
  ${({ appearance }) =>
    appearance === ButtonAppearance.ALFA &&
    css`
      ${baseButtonStyles}
    `}

  ${({ appearance }) =>
    appearance === ButtonAppearance.BRAVO &&
    css`
      ${baseButtonStyles}
      margin: 0 auto;
      max-width: 260px;
      width: 100%;
    `}

    ${({ appearance }) =>
    appearance === ButtonAppearance.CHARLIE &&
    css`
      ${baseButtonStyles}
      margin-top: 60px;
      max-width: 260px;
      width: 100%;
    `}

    ${mediaQuery('md')} {
    ${({ appearance }) =>
      appearance === ButtonAppearance.BRAVO &&
      css`
        font-size: 22px;
        height: 60px;
        max-width: 320px;
        width: 320px;
      `}

    ${({ appearance }) =>
      appearance === ButtonAppearance.CHARLIE &&
      css`
        font-size: 22px;
        height: 60px;
        margin: 60px 0 0 100px;
        max-width: 320px;
        width: 320px;
      `}
  }
`;

const StyledButton = styled(Link)`
  ${ButtonAppearancesStyles}
`;

interface ButtonProps {
  appearance: ButtonAppearance;
  children: React.ReactNode | string;
  url: string;
}

const Button: FC<ButtonProps> = ({ appearance, url, children }) => (
  <StyledButton to={url} appearance={appearance}>
    {children}
  </StyledButton>
);

export default Button;
